module.exports = __webpack_public_path__ + "img/Canes_venatici.3a8a6ac1.png";